import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BehaviorSubject, ReplaySubject, Subject, switchMap } from 'rxjs';
import { QQQuestionnaireViewModel } from 'src/app/models/qq-questionnaire.view-model';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { ApiService } from 'src/app/services/api.service';
import { QuestionnaireService } from 'src/app/services/questionnaire.service';
import { Loader } from 'src/app/util/loader';
import { SITE_CONTENT_CLICK, SiteContentClickEvent } from '../shared/site-content/site-content.component';

@Component({
  selector: 'apg-lead-gen',
  templateUrl: './apg-lead-gen.component.html',
  styleUrls: ['./apg-lead-gen.component.scss'],
  providers: [
    { provide: Loader, useValue: new Loader() },
    { provide: SITE_CONTENT_CLICK, useFactory: () => new Subject<SiteContentClickEvent>() }
  ]
})
export class ApgLeadGenComponent implements OnInit {

  @Input() name: string;
  @ViewChild(NgForm) form: NgForm;

  quickquote$ = new BehaviorSubject<QQQuestionnaireViewModel>(null);
  refresh$ = new ReplaySubject<boolean>(1);

  error: string = null;

  constructor(private api: ApiService,
    public loader: Loader,
    private analyticsService: AnalyticsService,
    private questionnaireService: QuestionnaireService
  ) { }

  ngOnInit() {}

  ngAfterViewInit() {
    this.refresh$.pipe(
      switchMap(x => this.loadViewModel())
    ).subscribe(this.quickquote$);

    this.refresh$.next(true);
  }

  async loadViewModel()
  {
    try {
      this.loader.loading = true;
      const model = await this.questionnaireService.getQuestionnaireViewModel(this.name, false);
      model.sourceUrl = this.analyticsService.getFullPath('lead_gen');

      this.analyticsService
      .mapTrackingData()?.map(x => model.saveAnswer(x.key, x.value)) ?? [];

      return model;
    } catch (e) {
      console.log(e);
      this.error = `Sorry, there was an error loading the ${this.name} questionnaire`;
    } finally {
      this.loader.loading = false;
    }
  }
}
